import ms from 'ms';

import {
  type ReprocessingInvoiceStatus,
  useQueryReprocessingInvoiceStatus,
} from '~/data/invoice-reprocessing';

import { REPROCESSING_INVOICE_STATUS_LABELS } from '../constants';

type P = {
  readonly processId: string;
  readonly refetchInterval?: number;
  readonly status?: ReprocessingInvoiceStatus;
  readonly valueFormatter?: (status: string) => string;
};

export const InvoiceReprocessingStatus = ({
  processId,
  refetchInterval = ms('5s'),
  status,
  valueFormatter = (value) => value,
}: P) => {
  const { data: liveStatus, isFetching } = useQueryReprocessingInvoiceStatus(
    processId,
    { refetchInterval },
  );

  const statusLabel =
    REPROCESSING_INVOICE_STATUS_LABELS[liveStatus ?? status ?? ''] ?? '';

  return valueFormatter(statusLabel || 'N/A');
};
